// backend/src/frontend/src/GlobalStyles.tsx
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';
import { tokens, monoStack } from './theme';

const GlobalStyles = () => (
  <MUIGlobalStyles
    styles={{
      body: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        padding: 0,
        width: '100vw',
        boxSizing: 'border-box',
        backgroundColor: tokens.canvas,
        color: tokens.ink,
        fontFamily: monoStack,
      },
      '*': { fontFamily: monoStack },
      pre: { fontFamily: monoStack },
      code: { fontFamily: monoStack },
    }}
  />
);

export default GlobalStyles;
